module.exports = "/images/vendor/flag-icon-css/flags/4x3/ky.svg?5814c5a94343cb013715ab05d3eac07b";